import React, { Component } from 'react'

import DisbursementRequest from "components/DisbursementRequest/DisbursementRequest";

export default class DisbursementRequestView extends Component {
    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <h1 className="header">Solicitud de Desembolso</h1>
                    </div>
                </div>

                <DisbursementRequest />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/views/DisbursementRequestView/DisbursementRequestView.jsx